import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { Link } from "react-router-dom";
import "../styles/404.css";

export default function FourOfour(){
    return <>
        <div className="wrapper-404">
            <Header type="default" />
            <div className="w-full bg-[#f4f4f5] grow flex flex-row items-center justify-center">
                <div className="main-container fancy">
                    <span className="title-sub bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">404</span>
                    <div className="flex flex-col items-start justify-between gap-[30px]">
                        <h1 className="main-title">Page non trouvée.</h1>
                        <p className="main-p font-dm-sans">L'URL recherché n'existe pas sur ce site.<br/><Link to="/" >Retourner à la page d'accueil.</Link></p>
                    </div>
                </div>
            </div>
            <FooterMaximized />
        </div>
    </>;
};